module.exports = __webpack_public_path__ + "img/8.5e3dc1b3.gif";